import { Controller } from "@hotwired/stimulus"

// Admin → Email Logs: clicking a row opens its details in a side panel — the
// full subject, project, exact time and every address, each with a copy
// button (Phelipe 2026-10-26). Links inside the row keep working as links.
export default class extends Controller {
  static targets = ["panel", "subject", "type", "project", "sent", "from", "to", "cc", "bcc"]

  open(event) {
    if (event.target.closest("a, button")) return

    const row = event.currentTarget
    let detail
    try { detail = JSON.parse(row.dataset.detail) } catch { return }

    this.element.querySelectorAll("tr[data-selected]").forEach(tr => {
      tr.removeAttribute("data-selected")
      tr.classList.remove("bg-surface")
    })
    row.setAttribute("data-selected", "")
    row.classList.add("bg-surface")

    this.subjectTarget.textContent = detail.subject || "(no subject)"
    this.typeTarget.textContent = detail.type || "—"
    this.sentTarget.textContent = detail.sent || "—"
    this._renderProject(detail)
    this._renderList(this.fromTarget, detail.from)
    this._renderList(this.toTarget, detail.to)
    this._renderList(this.ccTarget, detail.cc)
    this._renderList(this.bccTarget, detail.bcc)

    this.panelTarget.classList.remove("hidden")
  }

  close() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.add("hidden")
  }

  async copy(event) {
    const button = event.currentTarget
    try {
      await navigator.clipboard.writeText(button.dataset.email)
      button.textContent = "Copied"
      setTimeout(() => { button.textContent = "Copy" }, 1500)
    } catch {
      // Clipboard blocked (http, old browser): the address is still selectable.
    }
  }

  _renderProject(detail) {
    this.projectTarget.replaceChildren()
    if (!detail.project) {
      this.projectTarget.append(this._muted("—"))
      return
    }
    const link = document.createElement("a")
    link.href = detail.project_url
    link.target = "_blank"
    link.className = "text-brand hover:underline"
    link.textContent = `${detail.project} ↗`
    this.projectTarget.append(link)
  }

  _renderList(target, emails) {
    target.replaceChildren()
    if (!emails || emails.length === 0) {
      target.append(this._muted("—"))
      return
    }
    emails.forEach(email => {
      const line = document.createElement("div")
      line.className = "flex items-center justify-between gap-2"
      const text = document.createElement("span")
      text.className = "break-all select-all"
      text.textContent = email
      const button = document.createElement("button")
      button.type = "button"
      button.className = "shrink-0 text-[13px] text-brand hover:underline"
      button.textContent = "Copy"
      button.dataset.email = email
      button.dataset.action = "click->admin--email-log#copy"
      line.append(text, button)
      target.append(line)
    })
  }

  _muted(text) {
    const span = document.createElement("span")
    span.className = "text-text-muted"
    span.textContent = text
    return span
  }
}
